import { requestMediaPermissions, MediaPermissionsErrorType } from 'mic-check';

export async function requestPermissions(deviceId, attemptsLeft = 5) {
  try {
    await requestMediaPermissions({ audio: { deviceId } });
  } catch (err) {
    if (attemptsLeft > 0) {
      return new Promise((resolve) =>
        setTimeout(() => {
          resolve(requestPermissions(deviceId, attemptsLeft - 1));
        }, 100)
      );
    } else {
      if (err.type === MediaPermissionsErrorType.SystemPermissionDenied) {
        throw new Error(
          'Webbläsaren har inte tillgång till mikrofonen. Vänligen tillåt detta i system inställningarna.'
        );
      } else if (err.type === MediaPermissionsErrorType.UserPermissionDenied) {
        throw new Error(
          'Du har inte tillåtit webbläsaren att använda mikrofonen. Vänligen tillåt detta i inställningarna.'
        );
      } else {
        throw new Error(
          'Ett okänt fel uppstod när mikrofonen skulle aktiveras. Vänligen försök igen.'
        );
      }
    }
  }
}

export async function getStream(deviceId) {
  return navigator.mediaDevices.getUserMedia({
    audio: {
      deviceId,
      noiseSuppression: true,
      echoCancellation: true,
    },
  });
}

export async function getAudioDevices() {
  let devices = await navigator.mediaDevices.enumerateDevices();
  if (devices.every((d) => !d.label)) {
    const mockmedia = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: false,
    });
    devices = await navigator.mediaDevices.enumerateDevices();
    mockmedia.getTracks().forEach((track) => track.stop());
  }
  return devices.filter((device) => device.kind === 'audioinput');
}
